import { useGeolocation, usePermission } from "@vueuse/core";
import { ref, watch } from "vue";

export function getAirportQuery(
  locale: string,
  latitude?: number,
  longitude?: number
) {
  const queryParameters: Record<string, string> = {
    locale: locale,
  };
  if (latitude && longitude) {
    queryParameters["latitude"] = String(latitude);
    queryParameters["longitude"] = String(longitude);
  }
  const queryString = new URLSearchParams(queryParameters);
  return queryString.toString();
}

export function useOriginAirportQuery(locale: string) {
  const originAirportQuery = ref();

  const permissionGeoloc = usePermission("geolocation");

  const { coords, pause, resume } = useGeolocation({
    immediate: true,
  });

  watch(permissionGeoloc, (value) => {
    if (value === "granted") {
      resume();
    } else if (value === "denied") {
      pause();
      originAirportQuery.value = getAirportQuery(locale);
    }
  });

  watch(coords, (coords) => {
    const { accuracy, latitude, longitude } = coords;
    if (accuracy > 0) {
      originAirportQuery.value = getAirportQuery(locale, latitude, longitude);
    } else if (accuracy === 0) {
      originAirportQuery.value = getAirportQuery(locale);
    }
    pause();
  });

  return {
    originAirportQuery,
  };
}
